import { Component, ReactNode } from "react"

import SiNo, { getSiNoValue } from '../../components/siNo/SiNo'
import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'

import { NUMBER_PATTERN, isValid } from "../../libs/validation/stringRegex"
import { numberValidation } from "../../libs/validation/remoteValidationAbstract"

import { UserType } from "../../libs/user/User"

import Input from '../../libs/ui/inputs/Input'

interface HomeStepTreeProps {
    abitazione: boolean | undefined
    professione: boolean | undefined
    vincolato_belle_arti: boolean | undefined
    
    perizia: number | undefined

    assicurazione_incendio: boolean | undefined
    assicurazione_furto: boolean | undefined
    valore_beni: number | undefined

    user: UserType | undefined

    noMotorPrivacy: any

    abitazioneError: string | undefined
    professioneError: string | undefined
    vincolato_belle_artiError: string | undefined
    
    periziaError: string | undefined

    assicurazione_incendioError: string | undefined
    assicurazione_furtoError: string | undefined
    valore_beniError: string | undefined

    noMotorPrivacyError: string | undefined

    updateAbitazioneCallBack: Function
    updateProfessioneCallBack: Function
    updateVincolato_belle_artiCallBack: Function

    updatePeriziaCallBack: Function

    updateAssicurazione_incendioCallBack: Function
    updateAssicurazione_furtoCallBack: Function
    updateValore_beniCallBack: Function
    
    updateNoMotorPrivacyCallBack: Function

    expiredSessionCallbak: Function
}

class HomeStepTree extends Component<HomeStepTreeProps> {

    render (): ReactNode {
        return (
            <>
                <div className="col-12">
                    <Input 
                        id='perizia' name='perizia'
                        label='Valore di perizia dell’immobile'
                        value={this.props.perizia?.toString()}
                        type='number'
                        step='1'
                        min='1000'
                        regexp={this.isValidValorePerizia}
                        remoteValidation={numberValidation}
                        errorDisplayMsg={'Valore non valido'}
                        callback={this.props.updatePeriziaCallBack}
                        error={this.props.periziaError}
                    />

                    <SiNo 
                        id='abitazione' name="abitazione"
                        label='Vivi abitualmente in questa abitazione?'
                        value={ getSiNoValue( this.props.abitazione ) }
                        callback={this.props.updateAbitazioneCallBack}
                        error={this.props.abitazioneError}
                    />

                    <SiNo 
                        id='professione' name="professione"
                        label="L'abitazione è sede di attività commerciali?"
                        value={ getSiNoValue( this.props.professione ) }
                        callback={this.props.updateProfessioneCallBack}
                        error={this.props.professioneError}
                    />

                    <SiNo 
                        id='vincolato_belle_arti' name="vincolato_belle_arti"
                        label="L'immobile è tutelato o vincolato alle 'Belle Arti'?"
                        value={ getSiNoValue( this.props.vincolato_belle_arti ) }
                        callback={this.props.updateVincolato_belle_artiCallBack}
                        error={this.props.vincolato_belle_artiError}
                    />

                    <SiNo 
                        id='assicurazione_incendio' name="assicurazione_incendio"
                        label='Sei interessato a una polizza incendio?'
                        value={ getSiNoValue( this.props.assicurazione_incendio ) }
                        callback={this.props.updateAssicurazione_incendioCallBack}
                        error={this.props.assicurazione_incendioError}
                    />

                    <SiNo 
                        id='assicurazione_furto' name="assicurazione_furto"
                        label='Sei interessato a una polizza furto?'
                        value={ getSiNoValue( this.props.assicurazione_furto ) }
                        callback={this.props.updateAssicurazione_furtoCallBack}
                        error={this.props.assicurazione_furtoError}
                    />

                    {(this.props.assicurazione_incendio === true || this.props.assicurazione_furto === true) &&
                        <Input 
                            id='valore_beni' name='valore_beni'
                            label='Valore dei beni custoditi nell’immobile'
                            value={this.props.valore_beni?.toString()}
                            type='number'
                            step='1'
                            min='1'
                            regexp={NUMBER_PATTERN}
                            remoteValidation={numberValidation}
                            errorDisplayMsg={'Valore non valido'}
                            callback={this.props.updateValore_beniCallBack}
                            error={this.props.valore_beniError}
                        />
                    }
                </div>

                <NoMotorPrivacy 
                    id='noMotorPrivacy'
                    basePrivacy={this.props.noMotorPrivacy}
                    isLogged={this.props.user !== undefined}
                    callback={this.props.updateNoMotorPrivacyCallBack}
                    error={this.props.noMotorPrivacyError}
                />
            </>
        )
    }

    private isValidValorePerizia (val: string | undefined) {
        if (val !== undefined && isValid(val, NUMBER_PATTERN)) {
            const tmp = Number(val)
            return tmp >= 1000
        }

        return false
    }
}

export default HomeStepTree